import * as globals from "./globals";
import type { OctopusTheme } from "./OctopusTheme";
export const slateDarkTheme: OctopusTheme = {
    "colorAvatarBackgroundActionDefault": globals["colorScales"]["green"]["700"],
    "colorAvatarBackgroundActionHover": globals["colorScales"]["green"]["800"],
    "colorAvatarBackgroundImageDefault": globals["colorScales"]["slate"]["300"],
    "colorAvatarBackgroundImageHover": globals["colorScales"]["slate"]["400"],
    "colorAvatarBackgroundPageDefault": globals["colorScales"]["blue"]["700"],
    "colorAvatarBackgroundPageHover": globals["colorScales"]["blue"]["800"],
    "colorAvatarBackgroundProjectDefault": globals["colorScales"]["slate"]["600"],
    "colorAvatarBackgroundProjectHover": globals["colorScales"]["slate"]["700"],
    "colorAvatarBackgroundSpaceDefault": globals["colorScales"]["slate"]["600"],
    "colorAvatarBackgroundSpaceHover": globals["colorScales"]["slate"]["700"],
    "colorAvatarBackgroundTemplateDefault": globals["colorScales"]["slate"]["200"],
    "colorAvatarBackgroundTemplateHover": globals["colorScales"]["slate"]["300"],
    "colorAvatarBackgroundTenantDefault": globals["colorScales"]["white"],
    "colorAvatarBackgroundTenantHover": globals["colorScales"]["slate"]["100"],
    "colorAvatarBackgroundUserDefault": globals["colorScales"]["slate"]["600"],
    "colorAvatarBackgroundUserHover": globals["colorScales"]["slate"]["700"],
    "colorAvatarIconAction": globals["colorScales"]["green"]["200"],
    "colorAvatarIconPage": globals["colorScales"]["blue"]["200"],
    "colorAvatarIconPrimary": globals["colorScales"]["white"],
    "colorAvatarIconSecondary": globals["colorScales"]["slate"]["800"],
    "colorAvatarStackBackgroundHover": globals["colorScales"]["slate"]["800"],
    "colorAvatarStackBorder": globals["colorScales"]["slate"]["900"],
    "colorAvatarText": globals["colorScales"]["white"],
    "colorBackgroundBold": globals["colorScales"]["black"],
    "colorBackgroundDanger": globals["colorScales"]["red"]["700"],
    "colorBackgroundDefault": "rgb(from #16191F r g b / 0)",
    "colorBackgroundDisabled": globals["colorScales"]["slate"]["700"],
    "colorBackgroundFeature": globals["colorScales"]["purple"]["700"],
    "colorBackgroundHover": globals["colorScales"]["slate"]["800"],
    "colorBackgroundInfo": globals["colorScales"]["blue"]["700"],
    "colorBackgroundInverseDanger": globals["colorScales"]["red"]["600"],
    "colorBackgroundInverseFeature": globals["colorScales"]["purple"]["700"],
    "colorBackgroundInverseInfo": globals["colorScales"]["blue"]["600"],
    "colorBackgroundInverseNeutral": globals["colorScales"]["slate"]["400"],
    "colorBackgroundInverseNeutralQuiet": globals["colorScales"]["slate"]["200"],
    "colorBackgroundInversePrimary": globals["colorScales"]["white"],
    "colorBackgroundInverseSecondary": globals["colorScales"]["slate"]["300"],
    "colorBackgroundInverseSuccess": globals["colorScales"]["green"]["400"],
    "colorBackgroundInverseWarning": globals["colorScales"]["yellow"]["600"],
    "colorBackgroundNeutral": globals["colorScales"]["slate"]["800"],
    "colorBackgroundPrimaryDefault": globals["colorScales"]["slate"]["900"],
    "colorBackgroundPrimaryHover": globals["colorScales"]["slate"]["800"],
    "colorBackgroundPrimaryPressed": globals["colorScales"]["slate"]["700"],
    "colorBackgroundPrimaryTransparent": "rgb(from #16191F r g b / 0.3)",
    "colorBackgroundQuartaryDefault": globals["colorScales"]["slate"]["800"],
    "colorBackgroundQuartaryHover": globals["colorScales"]["slate"]["700"],
    "colorBackgroundQuartaryPressed": globals["colorScales"]["slate"]["900"],
    "colorBackgroundSecondaryDefault": globals["colorScales"]["slate"]["800"],
    "colorBackgroundSecondaryHover": globals["colorScales"]["slate"]["700"],
    "colorBackgroundSecondaryPressed": globals["colorScales"]["slate"]["900"],
    "colorBackgroundSecondaryTransparent": "rgb(from #16191F r g b / 0.3)",
    "colorBackgroundSelected": globals["colorScales"]["slate"]["200"],
    "colorBackgroundSuccess": globals["colorScales"]["green"]["700"],
    "colorBackgroundTertiary": globals["colorScales"]["slate"]["700"],
    "colorBackgroundWarning": globals["colorScales"]["yellow"]["600"],
    "colorBadgeBoldBackgroundDanger": globals["colorScales"]["red"]["600"],
    "colorBadgeBoldBackgroundFeature": globals["colorScales"]["purple"]["300"],
    "colorBadgeBoldBackgroundInfo": globals["colorScales"]["blue"]["600"],
    "colorBadgeBoldBackgroundInverseNeutral": globals["colorScales"]["slate"]["700"],
    "colorBadgeBoldBackgroundNeutral": globals["colorScales"]["slate"]["400"],
    "colorBadgeBoldBackgroundSuccess": globals["colorScales"]["green"]["600"],
    "colorBadgeBoldBackgroundUpsell": globals["colorScales"]["purple"]["300"],
    "colorBadgeBoldBackgroundWarning": globals["colorScales"]["yellow"]["500"],
    "colorBadgeBoldIconFeature": globals["colorScales"]["purple"]["800"],
    "colorBadgeBoldIconPrimary": globals["colorScales"]["white"],
    "colorBadgeBoldIconSecondary": globals["colorScales"]["black"],
    "colorBadgeBoldIconUpsell": globals["colorScales"]["purple"]["800"],
    "colorBadgeBoldTextFeature": globals["colorScales"]["purple"]["800"],
    "colorBadgeBoldTextPrimary": globals["colorScales"]["white"],
    "colorBadgeBoldTextSecondary": globals["colorScales"]["black"],
    "colorBadgeBoldTextUpsell": globals["colorScales"]["purple"]["800"],
    "colorBadgeSubtleBackgroundDanger": globals["colorScales"]["red"]["800"],
    "colorBadgeSubtleBackgroundFeature": globals["colorScales"]["purple"]["800"],
    "colorBadgeSubtleBackgroundInfo": globals["colorScales"]["blue"]["800"],
    "colorBadgeSubtleBackgroundNeutral": globals["colorScales"]["slate"]["800"],
    "colorBadgeSubtleBackgroundSuccess": globals["colorScales"]["green"]["800"],
    "colorBadgeSubtleBackgroundUpsell": globals["colorScales"]["purple"]["800"],
    "colorBadgeSubtleBackgroundWarning": globals["colorScales"]["yellow"]["800"],
    "colorBadgeSubtleBorderDanger": globals["colorScales"]["red"]["700"],
    "colorBadgeSubtleBorderFeature": globals["colorScales"]["purple"]["700"],
    "colorBadgeSubtleBorderInfo": globals["colorScales"]["blue"]["700"],
    "colorBadgeSubtleBorderNeutral": globals["colorScales"]["slate"]["700"],
    "colorBadgeSubtleBorderSuccess": globals["colorScales"]["green"]["700"],
    "colorBadgeSubtleBorderUpsell": globals["colorScales"]["purple"]["700"],
    "colorBadgeSubtleBorderWarning": globals["colorScales"]["yellow"]["700"],
    "colorBadgeSubtleIconDanger": globals["colorScales"]["red"]["300"],
    "colorBadgeSubtleIconFeature": globals["colorScales"]["purple"]["300"],
    "colorBadgeSubtleIconInfo": globals["colorScales"]["blue"]["300"],
    "colorBadgeSubtleIconNeutral": globals["colorScales"]["slate"]["300"],
    "colorBadgeSubtleIconSuccess": globals["colorScales"]["green"]["300"],
    "colorBadgeSubtleIconUpsell": globals["colorScales"]["purple"]["300"],
    "colorBadgeSubtleIconWarning": globals["colorScales"]["yellow"]["300"],
    "colorBadgeSubtleTextDanger": globals["colorScales"]["red"]["200"],
    "colorBadgeSubtleTextFeature": globals["colorScales"]["purple"]["200"],
    "colorBadgeSubtleTextInfo": globals["colorScales"]["blue"]["200"],
    "colorBadgeSubtleTextNeutral": globals["colorScales"]["slate"]["300"],
    "colorBadgeSubtleTextSuccess": globals["colorScales"]["green"]["200"],
    "colorBadgeSubtleTextUpsell": globals["colorScales"]["purple"]["200"],
    "colorBadgeSubtleTextWarning": globals["colorScales"]["yellow"]["100"],
    "colorBorderBold": globals["colorScales"]["slate"]["400"],
    "colorBorderDanger": globals["colorScales"]["red"]["400"],
    "colorBorderDefault": globals["colorScales"]["slate"]["500"],
    "colorBorderDisabled": globals["colorScales"]["slate"]["600"],
    "colorBorderFeature": globals["colorScales"]["purple"]["400"],
    "colorBorderInfo": globals["colorScales"]["blue"]["400"],
    "colorBorderInversePrimary": globals["colorScales"]["slate"]["200"],
    "colorBorderInverseSecondary": globals["colorScales"]["slate"]["100"],
    "colorBorderLinkDefault": globals["colorScales"]["slate"]["300"],
    "colorBorderLinkHover": globals["colorScales"]["slate"]["100"],
    "colorBorderPrimary": globals["colorScales"]["slate"]["700"],
    "colorBorderSecondary": globals["colorScales"]["slate"]["800"],
    "colorBorderSelected": globals["colorScales"]["slate"]["400"],
    "colorBorderSuccess": globals["colorScales"]["green"]["400"],
    "colorBorderTertiary": globals["colorScales"]["slate"]["600"],
    "colorBorderWarning": globals["colorScales"]["yellow"]["300"],
    "colorButtonBackgroundDestructiveDefault": globals["colorScales"]["red"]["500"],
    "colorButtonBackgroundDestructiveHover": globals["colorScales"]["red"]["600"],
    "colorButtonBackgroundDestructivePressed": globals["colorScales"]["red"]["700"],
    "colorButtonBackgroundDisabled": "rgb(from #282F38 r g b / 0.56)",
    "colorButtonBackgroundGhostDefault": "rgb(from #8A96A7 r g b / 0)",
    "colorButtonBackgroundGhostHover": "rgb(from #8A96A7 r g b / 0.12)",
    "colorButtonBackgroundGhostPressed": "rgb(from #8A96A7 r g b / 0.2)",
    "colorButtonBackgroundLoudDefault": globals["colorScales"]["slate"]["200"],
    "colorButtonBackgroundLoudHover": globals["colorScales"]["slate"]["300"],
    "colorButtonBackgroundLoudPressed": globals["colorScales"]["slate"]["400"],
    "colorButtonBackgroundNeutralDefault": "rgb(from #8A96A7 r g b / 0.2)",
    "colorButtonBackgroundNeutralHover": "rgb(from #8A96A7 r g b / 0.28)",
    "colorButtonBackgroundNeutralPressed": "rgb(from #8A96A7 r g b / 0.36)",
    "colorButtonBackgroundPrimaryDefault": globals["colorScales"]["slate"]["100"],
    "colorButtonBackgroundPrimaryHover": globals["colorScales"]["slate"]["300"],
    "colorButtonBackgroundPrimaryPressed": globals["colorScales"]["slate"]["400"],
    "colorButtonBackgroundQuietDefault": "rgb(from #8A96A7 r g b / 0)",
    "colorButtonBackgroundQuietHover": "rgb(from #8A96A7 r g b / 0.12)",
    "colorButtonBackgroundQuietPressed": "rgb(from #000000 r g b / 0.4)",
    "colorButtonBackgroundSecondaryDefault": "rgb(from #8A96A7 r g b / 0)",
    "colorButtonBackgroundSecondaryHover": "rgb(from #8A96A7 r g b / 0.12)",
    "colorButtonBackgroundSecondaryPressed": "rgb(from #8A96A7 r g b / 0.2)",
    "colorButtonBackgroundTertiaryDefault": "rgb(from #8A96A7 r g b / 0.2)",
    "colorButtonBackgroundTertiaryHover": "rgb(from #8A96A7 r g b / 0.28)",
    "colorButtonBackgroundTertiaryPressed": "rgb(from #8A96A7 r g b / 0.36)",
    "colorButtonBorderDisabled": globals["colorScales"]["slate"]["700"],
    "colorButtonBorderSecondary": globals["colorScales"]["slate"]["400"],
    "colorButtonFocus": globals["colorScales"]["slate"]["300"],
    "colorButtonIconDestructive": globals["colorScales"]["white"],
    "colorButtonIconDisabled": globals["colorScales"]["slate"]["600"],
    "colorButtonIconGhost": globals["colorScales"]["slate"]["100"],
    "colorButtonIconLoud": globals["colorScales"]["slate"]["900"],
    "colorButtonIconNeutral": globals["colorScales"]["slate"]["300"],
    "colorButtonIconPrimary": globals["colorScales"]["slate"]["900"],
    "colorButtonIconQuietDefault": globals["colorScales"]["slate"]["400"],
    "colorButtonIconQuietHover": globals["colorScales"]["slate"]["300"],
    "colorButtonIconQuietPressed": globals["colorScales"]["slate"]["300"],
    "colorButtonIconSecondary": globals["colorScales"]["slate"]["100"],
    "colorButtonIconTertiaryDefault": globals["colorScales"]["slate"]["300"],
    "colorButtonIconTertiaryHover": globals["colorScales"]["slate"]["100"],
    "colorButtonIconTertiaryPressed": globals["colorScales"]["slate"]["100"],
    "colorButtonTextDestructive": globals["colorScales"]["white"],
    "colorButtonTextDisabled": globals["colorScales"]["slate"]["600"],
    "colorButtonTextGhost": globals["colorScales"]["slate"]["100"],
    "colorButtonTextLoud": globals["colorScales"]["slate"]["900"],
    "colorButtonTextNeutral": globals["colorScales"]["slate"]["300"],
    "colorButtonTextPrimary": globals["colorScales"]["slate"]["900"],
    "colorButtonTextQuietDefault": globals["colorScales"]["slate"]["400"],
    "colorButtonTextQuietHover": globals["colorScales"]["slate"]["300"],
    "colorButtonTextQuietPressed": globals["colorScales"]["slate"]["300"],
    "colorButtonTextSecondary": globals["colorScales"]["slate"]["100"],
    "colorButtonTextTertiaryDefault": globals["colorScales"]["slate"]["300"],
    "colorButtonTextTertiaryHover": globals["colorScales"]["slate"]["100"],
    "colorButtonTextTertiaryPressed": globals["colorScales"]["slate"]["100"],
    "colorCalloutBackgroundDangerDefault": "rgb(from #571818 r g b / 0.8)",
    "colorCalloutBackgroundDangerHover": "rgb(from #AA3030 r g b / 0.48)",
    "colorCalloutBackgroundDangerPressed": "rgb(from #AA3030 r g b / 0.32)",
    "colorCalloutBackgroundFeatureDefault": "rgb(from #3B1D66 r g b / 0.75)",
    "colorCalloutBackgroundFeatureHover": "rgb(from #7043B7 r g b / 0.48)",
    "colorCalloutBackgroundFeaturePressed": "rgb(from #7043B7 r g b / 0.32)",
    "colorCalloutBackgroundInfoDefault": "rgb(from #8A96A7 r g b / 0.16)",
    "colorCalloutBackgroundInfoHover": "rgb(from #8A96A7 r g b / 0.24)",
    "colorCalloutBackgroundInfoPressed": "rgb(from #8A96A7 r g b / 0.32)",
    "colorCalloutBackgroundSuccessDefault": "rgb(from #00361F r g b / 0.75)",
    "colorCalloutBackgroundSuccessHover": "rgb(from #006A3D r g b / 0.48)",
    "colorCalloutBackgroundSuccessPressed": "rgb(from #006A3D r g b / 0.32)",
    "colorCalloutBackgroundUpsell": "linear-gradient(95deg, rgb(from #0F4778 r g b / 0.5) 0%, rgb(from #572B97 r g b / 0.5) 100%)",
    "colorCalloutBackgroundWarningDefault": "rgb(from #584201 r g b / 0.9)",
    "colorCalloutBackgroundWarningHover": "rgb(from #745801 r g b / 0.56)",
    "colorCalloutBackgroundWarningPressed": "rgb(from #745801 r g b / 0.4)",
    "colorCalloutBorderDanger": globals["colorScales"]["red"]["400"],
    "colorCalloutBorderDefault": globals["colorScales"]["navy"]["500"],
    "colorCalloutBorderFeature": globals["colorScales"]["purple"]["400"],
    "colorCalloutBorderInfo": globals["colorScales"]["slate"]["400"],
    "colorCalloutBorderSuccess": globals["colorScales"]["green"]["400"],
    "colorCalloutBorderUpsell": "linear-gradient(180deg, #1A77CA 0%, #895ED3 100%)",
    "colorCalloutBorderWarning": globals["colorScales"]["yellow"]["400"],
    "colorCalloutCodeBackground": globals["colorScales"]["slate"]["300"],
    "colorCalloutIconDanger": globals["colorScales"]["red"]["300"],
    "colorCalloutIconFeature": globals["colorScales"]["purple"]["300"],
    "colorCalloutIconInfo": globals["colorScales"]["slate"]["300"],
    "colorCalloutIconSuccess": globals["colorScales"]["green"]["300"],
    "colorCalloutIconWarning": globals["colorScales"]["yellow"]["200"],
    "colorCalloutTextBody": globals["colorScales"]["slate"]["200"],
    "colorCalloutTextDanger": globals["colorScales"]["red"]["200"],
    "colorCalloutTextFeature": globals["colorScales"]["purple"]["200"],
    "colorCalloutTextInfo": globals["colorScales"]["slate"]["100"],
    "colorCalloutTextSuccess": globals["colorScales"]["green"]["200"],
    "colorCalloutTextWarning": globals["colorScales"]["yellow"]["100"],
    "colorCanvasBackground": globals["colorScales"]["slate"]["800"],
    "colorCanvasPattern": globals["colorScales"]["slate"]["900"],
    "colorCardBackgroundPrimaryDefault": globals["colorScales"]["slate"]["800"],
    "colorCardBackgroundSecondaryDefault": "rgb(from #16191F r g b / 0)",
    "colorCardBackgroundSecondaryHover": "rgb(from #282F38 r g b / 0.64)",
    "colorCardChartBackgroundDefault": "rgb(from #282F38 r g b / 0.3)",
    "colorCardChartBackgroundHover": "rgb(from #282F38 r g b / 0.5)",
    "colorCarouselBackgroundPrimary": globals["colorScales"]["slate"]["900"],
    "colorCarouselIconDefault": "rgb(from #B2B9C5 r g b / 0.32)",
    "colorCarouselIconHover": "rgb(from #B2B9C5 r g b / 0.72)",
    "colorCarouselIconSelected": globals["colorScales"]["blue"]["400"],
    "colorCarouselTextPrimary": globals["colorScales"]["white"],
    "colorCategorySelectListBackgroundActive": "rgb(from #1A77CA r g b / 0.24)",
    "colorCategorySelectListBackgroundDefault": globals["colorScales"]["slate"]["800"],
    "colorCategorySelectListBackgroundHover": globals["colorScales"]["blue"]["500"],
    "colorCategorySelectListIconActive": globals["colorScales"]["blue"]["400"],
    "colorCategorySelectListIconDefault": globals["colorScales"]["slate"]["300"],
    "colorCategorySelectListIconHover": globals["colorScales"]["white"],
    "colorCategorySelectListTextActive": globals["colorScales"]["blue"]["400"],
    "colorCategorySelectListTextHover": globals["colorScales"]["white"],
    "colorChipBackgroundDanger": globals["colorScales"]["red"]["500"],
    "colorChipBackgroundPrimary": globals["colorScales"]["slate"]["700"],
    "colorChipBackgroundSecondary": globals["colorScales"]["blue"]["600"],
    "colorChipBackgroundSuccessful": globals["colorScales"]["green"]["500"],
    "colorChipBorderPrimary": globals["colorScales"]["slate"]["600"],
    "colorChipFilledBackgroundDanger": globals["colorScales"]["red"]["700"],
    "colorChipFilledBackgroundInfo": globals["colorScales"]["blue"]["700"],
    "colorChipFilledBackgroundPrimary": globals["colorScales"]["slate"]["700"],
    "colorChipFilledBackgroundSecondary": globals["colorScales"]["purple"]["700"],
    "colorChipFilledBackgroundSuccess": globals["colorScales"]["green"]["700"],
    "colorChipFilledBackgroundWarning": globals["colorScales"]["yellow"]["700"],
    "colorChipFilledIconDanger": globals["colorScales"]["red"]["200"],
    "colorChipFilledIconInfo": globals["colorScales"]["blue"]["200"],
    "colorChipFilledIconPrimary": globals["colorScales"]["slate"]["200"],
    "colorChipFilledIconSecondary": globals["colorScales"]["purple"]["200"],
    "colorChipFilledIconSuccess": globals["colorScales"]["green"]["200"],
    "colorChipFilledIconWarning": globals["colorScales"]["yellow"]["200"],
    "colorChipFilledTextDanger": globals["colorScales"]["red"]["200"],
    "colorChipFilledTextInfo": globals["colorScales"]["blue"]["200"],
    "colorChipFilledTextPrimary": globals["colorScales"]["slate"]["200"],
    "colorChipFilledTextSecondary": globals["colorScales"]["purple"]["200"],
    "colorChipFilledTextSuccess": globals["colorScales"]["green"]["200"],
    "colorChipFilledTextWarning": globals["colorScales"]["yellow"]["200"],
    "colorChipIconInverse": globals["colorScales"]["white"],
    "colorChipIconPrimary": globals["colorScales"]["white"],
    "colorChipIconWarning": globals["colorScales"]["orange"]["500"],
    "colorChipOutlinedBorderDanger": globals["colorScales"]["red"]["400"],
    "colorChipOutlinedBorderInfo": globals["colorScales"]["blue"]["400"],
    "colorChipOutlinedBorderPrimary": globals["colorScales"]["navy"]["400"],
    "colorChipOutlinedBorderSecondary": globals["colorScales"]["purple"]["400"],
    "colorChipOutlinedBorderSuccess": globals["colorScales"]["green"]["400"],
    "colorChipOutlinedBorderWarning": globals["colorScales"]["yellow"]["400"],
    "colorChipOutlinedIconDanger": globals["colorScales"]["red"]["400"],
    "colorChipOutlinedIconInfo": globals["colorScales"]["blue"]["400"],
    "colorChipOutlinedIconPrimary": globals["colorScales"]["slate"]["400"],
    "colorChipOutlinedIconSecondary": globals["colorScales"]["purple"]["400"],
    "colorChipOutlinedIconSuccess": globals["colorScales"]["green"]["400"],
    "colorChipOutlinedIconWarning": globals["colorScales"]["yellow"]["400"],
    "colorChipOutlinedTextDanger": globals["colorScales"]["red"]["400"],
    "colorChipOutlinedTextInfo": globals["colorScales"]["blue"]["400"],
    "colorChipOutlinedTextPrimary": globals["colorScales"]["slate"]["400"],
    "colorChipOutlinedTextSecondary": globals["colorScales"]["purple"]["400"],
    "colorChipOutlinedTextSuccess": globals["colorScales"]["green"]["400"],
    "colorChipOutlinedTextWarning": globals["colorScales"]["yellow"]["400"],
    "colorChipTextInverse": globals["colorScales"]["slate"]["800"],
    "colorChipTextPrimary": globals["colorScales"]["white"],
    "colorCodeEditorBackground": globals["colorScales"]["slate"]["900"],
    "colorCodeEditorCodeActivelineBackground": "rgb(from #7C98B4 r g b / 0.15)",
    "colorCodeEditorCodeAtomNumberKeywordVariableAttributeQuoteColor": globals["colorScales"]["blue"]["400"],
    "colorCodeEditorCodeBracketCommentColor": globals["colorScales"]["grey"]["400"],
    "colorCodeEditorCodeCursorBorderLeft": globals["colorScales"]["slate"]["300"],
    "colorCodeEditorCodeCursorBorderRight": globals["colorScales"]["slate"]["300"],
    "colorCodeEditorCodeDefTagBuiltinQualifierHeaderEmColor": globals["colorScales"]["red"]["300"],
    "colorCodeEditorCodeErrorInvalidcharColor": globals["colorScales"]["red"]["400"],
    "colorCodeEditorCodeFatCursorBackground": globals["colorScales"]["slate"]["300"],
    "colorCodeEditorCodeHint": globals["colorScales"]["slate"]["100"],
    "colorCodeEditorCodeHintActiveBackground": globals["colorScales"]["slate"]["800"],
    "colorCodeEditorCodeHintsBackground": globals["colorScales"]["slate"]["800"],
    "colorCodeEditorCodeIndentationMarkerActiveColor": globals["colorScales"]["slate"]["600"],
    "colorCodeEditorCodeIndentationMarkerColor": globals["colorScales"]["slate"]["800"],
    "colorCodeEditorCodeLinenumberColor": globals["colorScales"]["slate"]["400"],
    "colorCodeEditorCodeMatchingbracketColor": globals["colorScales"]["slate"]["400"],
    "colorCodeEditorCodePositiveColor": globals["colorScales"]["green"]["400"],
    "colorCodeEditorCodePropertyColor": globals["colorScales"]["orange"]["300"],
    "colorCodeEditorCodePunctuationUnitNegativeColor": globals["colorScales"]["red"]["200"],
    "colorCodeEditorCodeSelectedBackground": globals["colorScales"]["slate"]["800"],
    "colorCodeEditorCodeStringOperatorColor": globals["colorScales"]["green"]["300"],
    "colorCodeEditorCodeSyntaxAtom": globals["colorScales"]["orange"]["300"],
    "colorCodeEditorCodeSyntaxAttributeName": globals["colorScales"]["blue"]["300"],
    "colorCodeEditorCodeSyntaxBool": globals["colorScales"]["orange"]["300"],
    "colorCodeEditorCodeSyntaxBracket": globals["colorScales"]["slate"]["400"],
    "colorCodeEditorCodeSyntaxClassName": globals["colorScales"]["purple"]["300"],
    "colorCodeEditorCodeSyntaxComment": globals["colorScales"]["slate"]["400"],
    "colorCodeEditorCodeSyntaxDeleted": globals["colorScales"]["red"]["200"],
    "colorCodeEditorCodeSyntaxDeletedBackground": globals["colorScales"]["red"]["100"],
    "colorCodeEditorCodeSyntaxEmphasis": globals["colorScales"]["purple"]["300"],
    "colorCodeEditorCodeSyntaxEscape": globals["colorScales"]["blue"]["200"],
    "colorCodeEditorCodeSyntaxHeading": globals["colorScales"]["purple"]["300"],
    "colorCodeEditorCodeSyntaxInvalid": globals["colorScales"]["red"]["400"],
    "colorCodeEditorCodeSyntaxKeyword": globals["colorScales"]["red"]["300"],
    "colorCodeEditorCodeSyntaxLink": globals["colorScales"]["blue"]["200"],
    "colorCodeEditorCodeSyntaxMeta": globals["colorScales"]["blue"]["200"],
    "colorCodeEditorCodeSyntaxName": globals["colorScales"]["green"]["300"],
    "colorCodeEditorCodeSyntaxNumber": globals["colorScales"]["blue"]["300"],
    "colorCodeEditorCodeSyntaxOperator": globals["colorScales"]["blue"]["300"],
    "colorCodeEditorCodeSyntaxPropertyName": globals["colorScales"]["purple"]["300"],
    "colorCodeEditorCodeSyntaxQuote": globals["colorScales"]["green"]["300"],
    "colorCodeEditorCodeSyntaxRegexp": globals["colorScales"]["blue"]["200"],
    "colorCodeEditorCodeSyntaxSpecialVariableName": globals["colorScales"]["orange"]["300"],
    "colorCodeEditorCodeSyntaxString": globals["colorScales"]["blue"]["200"],
    "colorCodeEditorCodeSyntaxStrong": globals["colorScales"]["purple"]["300"],
    "colorCodeEditorCodeSyntaxTagName": globals["colorScales"]["green"]["300"],
    "colorCodeEditorCodeSyntaxTypeName": globals["colorScales"]["red"]["300"],
    "colorCodeEditorCodeSyntaxTypeOperator": globals["colorScales"]["red"]["300"],
    "colorCodeEditorCodeSyntaxUrl": globals["colorScales"]["blue"]["200"],
    "colorCodeEditorCodeSyntaxVariableName": globals["colorScales"]["blue"]["300"],
    "colorCodeEditorCodeVariable2Variable3String2UrlColor": globals["colorScales"]["blue"]["300"],
    "colorCodeEditorCodeVariableColor": globals["colorScales"]["purple"]["300"],
    "colorCodeEditorForeground": globals["colorScales"]["slate"]["200"],
    "colorCodeEditorSelection": globals["colorScales"]["blue"]["700"],
    "colorCodeEditorSelectionMatch": globals["colorScales"]["blue"]["700"],
    "colorCodeEditorTextDefault": globals["colorScales"]["slate"]["200"],
    "colorCodeEditorTextGutter": globals["colorScales"]["navy"]["400"],
    "colorCodeEditorTextHighlight": globals["colorScales"]["orange"]["200"],
    "colorCodeEditorTextHintHighlight": globals["colorScales"]["green"]["200"],
    "colorCodeEditorToolbarBackground": globals["colorScales"]["slate"]["800"],
    "colorCodeEditorToolbarButtonHover": globals["colorScales"]["slate"]["900"],
    "colorCodeReviewBackgroundDangerDefault": globals["colorScales"]["red"]["800"],
    "colorCodeReviewBackgroundDangerMuted": globals["colorScales"]["red"]["700"],
    "colorCodeReviewBackgroundPrimaryDefault": globals["colorScales"]["slate"]["900"],
    "colorCodeReviewBackgroundPrimaryMuted": globals["colorScales"]["slate"]["800"],
    "colorCodeReviewBackgroundSuccessDefault": globals["colorScales"]["green"]["800"],
    "colorCodeReviewBackgroundSuccessMuted": globals["colorScales"]["green"]["700"],
    "colorCodeReviewTextDanger": globals["colorScales"]["red"]["300"],
    "colorCodeReviewTextPrimary": globals["colorScales"]["navy"]["100"],
    "colorCodeReviewTextSuccess": globals["colorScales"]["green"]["300"],
    "colorDeprecatedBackgroundWarning": globals["colorScales"]["orange"]["700"],
    "colorDeprecatedBorderWarning": globals["colorScales"]["orange"]["400"],
    "colorDeprecatedIconWarning": globals["colorScales"]["orange"]["400"],
    "colorDeprecatedTextWarning": globals["colorScales"]["orange"]["300"],
    "colorDialogBackgroundPrimary": globals["colorScales"]["slate"]["800"],
    "colorDialogBackgroundSecondaryDefault": globals["colorScales"]["slate"]["700"],
    "colorDialogBackgroundSecondaryUpsell": "linear-gradient(95deg, rgb(from #1A77CA r g b / 0.6) 0%, rgb(from #895ED3 r g b / 0.6) 100%)",
    "colorDialogHelpPanelText": globals["colorScales"]["white"],
    "colorFormLegendBackgroundHover": globals["colorScales"]["slate"]["700"],
    "colorFormLegendBackgroundRest": globals["colorScales"]["slate"]["800"],
    "colorFreezeStatusBorder": globals["colorScales"]["blue"]["600"],
    "colorFreezeStatusIcon": globals["colorScales"]["blue"]["200"],
    "colorHealthStatusBackgroundExecuting": globals["colorScales"]["blue"]["600"],
    "colorHealthStatusBackgroundFailure": globals["colorScales"]["red"]["600"],
    "colorHealthStatusBackgroundNeutral": globals["colorScales"]["slate"]["600"],
    "colorHealthStatusBackgroundSuccess": globals["colorScales"]["green"]["600"],
    "colorHealthStatusBackgroundWarning": globals["colorScales"]["yellow"]["600"],
    "colorHealthStatusIconDefault": globals["colorScales"]["white"],
    "colorHealthStatusIconInverse": globals["colorScales"]["slate"]["100"],
    "colorIconDanger": globals["colorScales"]["red"]["400"],
    "colorIconDisabled": globals["colorScales"]["slate"]["600"],
    "colorIconFeature": globals["colorScales"]["purple"]["400"],
    "colorIconInfo": globals["colorScales"]["slate"]["300"],
    "colorIconInversePrimary": globals["colorScales"]["slate"]["900"],
    "colorIconInverseSecondary": globals["colorScales"]["slate"]["800"],
    "colorIconLinkDefault": globals["colorScales"]["slate"]["300"],
    "colorIconLinkHover": globals["colorScales"]["slate"]["400"],
    "colorIconPrimary": globals["colorScales"]["slate"]["100"],
    "colorIconSecondary": globals["colorScales"]["slate"]["300"],
    "colorIconSelected": globals["colorScales"]["slate"]["200"],
    "colorIconSuccess": globals["colorScales"]["green"]["400"],
    "colorIconTertiary": globals["colorScales"]["slate"]["400"],
    "colorIconWarning": globals["colorScales"]["yellow"]["300"],
    "colorLifecycleBackgroundPrimary": globals["colorScales"]["slate"]["500"],
    "colorLifecycleBorderDefault": globals["colorScales"]["slate"]["300"],
    "colorLifecycleIconPrimary": globals["colorScales"]["white"],
    "colorLifecycleTextPrimary": globals["colorScales"]["slate"]["100"],
    "colorMenuListBackgroundActive": globals["colorScales"]["slate"]["600"],
    "colorMenuListBackgroundDefault": globals["colorScales"]["slate"]["800"],
    "colorMenuListBackgroundHover": globals["colorScales"]["slate"]["700"],
    "colorMenuListBorderPrimary": globals["colorScales"]["slate"]["600"],
    "colorMenuListIconPrimary": globals["colorScales"]["slate"]["400"],
    "colorMenuListTextHighlight": globals["colorScales"]["blue"]["400"],
    "colorMenuListTextPrimary": globals["colorScales"]["slate"]["100"],
    "colorMenuListTextSecondary": globals["colorScales"]["slate"]["200"],
    "colorNavButtonBackgroundActive": globals["colorScales"]["slate"]["800"],
    "colorNavButtonBackgroundDefault": "rgb(from #F5F6F8 r g b / 0.01)",
    "colorNavButtonBackgroundHover": globals["colorScales"]["slate"]["800"],
    "colorNavButtonBackgroundPressed": globals["colorScales"]["slate"]["700"],
    "colorNavButtonIconActive": globals["colorScales"]["slate"]["100"],
    "colorNavButtonIconDefault": globals["colorScales"]["slate"]["100"],
    "colorNavButtonIconHover": globals["colorScales"]["slate"]["100"],
    "colorNavButtonIconPressed": globals["colorScales"]["slate"]["100"],
    "colorNavListBackgroundActive": "rgb(from #282F38 r g b / 0.7)",
    "colorNavListBackgroundDefault": "rgb(from #68778D r g b / 0)",
    "colorNavListBackgroundHover": globals["colorScales"]["slate"]["600"],
    "colorNavListIconActive": globals["colorScales"]["slate"]["400"],
    "colorNavListIconDefault": globals["colorScales"]["slate"]["600"],
    "colorNavListTextActive": globals["colorScales"]["slate"]["400"],
    "colorNavListTextDefault": globals["colorScales"]["navy"]["100"],
    "colorNavListTextHover": globals["colorScales"]["white"],
    "colorNavTabBackgroundActive": "rgb(from #FFFFFF r g b / 0)",
    "colorNavTabBackgroundHover": globals["colorScales"]["slate"]["700"],
    "colorNavTabBorderPrimary": globals["colorScales"]["slate"]["400"],
    "colorNavTabIconActive": globals["colorScales"]["slate"]["300"],
    "colorNavTabIconDefault": globals["colorScales"]["white"],
    "colorNavTabIconHover": globals["colorScales"]["white"],
    "colorNavTabTextActive": globals["colorScales"]["slate"]["300"],
    "colorNavTabTextDefault": globals["colorScales"]["white"],
    "colorNavTabTextHover": globals["colorScales"]["white"],
    "colorOverlayPrimary": "rgb(from #282F38 r g b / 0.56)",
    "colorOverlaySecondary": "rgb(from #000000 r g b / 0.31)",
    "colorPaginationBackgroundActive": globals["colorScales"]["blue"]["400"],
    "colorPaginationBackgroundDefault": globals["colorScales"]["slate"]["900"],
    "colorPaginationBackgroundDisabled": globals["colorScales"]["slate"]["900"],
    "colorPaginationBackgroundHover": globals["colorScales"]["navy"]["500"],
    "colorPaginationIconActive": globals["colorScales"]["slate"]["900"],
    "colorPaginationIconDefault": globals["colorScales"]["slate"]["100"],
    "colorPaginationIconDisabled": globals["colorScales"]["slate"]["600"],
    "colorPaginationIconHover": globals["colorScales"]["white"],
    "colorPaginationTextActive": globals["colorScales"]["slate"]["900"],
    "colorPaginationTextDefault": globals["colorScales"]["slate"]["100"],
    "colorPaginationTextDisabled": globals["colorScales"]["slate"]["600"],
    "colorPaginationTextHover": globals["colorScales"]["white"],
    "colorParallelChipBackground": globals["colorScales"]["slate"]["500"],
    "colorParallelChipIcon": globals["colorScales"]["white"],
    "colorPopoverBackgroundPrimary": globals["colorScales"]["slate"]["900"],
    "colorPopoverBackgroundSecondary": globals["colorScales"]["slate"]["800"],
    "colorPopoverInfoCircleBackgroundDefault": globals["colorScales"]["slate"]["300"],
    "colorPopoverInfoCircleBackgroundHover": globals["colorScales"]["slate"]["500"],
    "colorPopoverInfoCircleTextDefault": globals["colorScales"]["slate"]["700"],
    "colorPopoverInfoCircleTextHover": globals["colorScales"]["slate"]["100"],
    "colorPortalCardBackground": globals["colorScales"]["navy"]["700"],
    "colorPortalCardContentDisabled": globals["colorScales"]["navy"]["300"],
    "colorPortalCardContentText": globals["colorScales"]["navy"]["200"],
    "colorPortalChipBackground": globals["colorScales"]["navy"]["700"],
    "colorPortalLinkTextHover": globals["colorScales"]["white"],
    "colorPortalLogoBackground": globals["colorScales"]["blue"]["100"],
    "colorPortalPopoverBackground": globals["colorScales"]["navy"]["700"],
    "colorProcessContainerBackgroundSelected": globals["colorScales"]["slate"]["700"],
    "colorProcessContainerBorderSelected": globals["colorScales"]["slate"]["600"],
    "colorProcessStepBackgroundErrorPrimary": globals["colorScales"]["red"]["800"],
    "colorProcessStepBackgroundErrorSecondary": globals["colorScales"]["red"]["600"],
    "colorProcessStepBackgroundErrorSelected": globals["colorScales"]["red"]["700"],
    "colorProcessStepBackgroundHoverError": globals["colorScales"]["red"]["700"],
    "colorProcessStepBackgroundHoverPrimary": globals["colorScales"]["slate"]["800"],
    "colorProcessStepBackgroundHoverSecondary": globals["colorScales"]["slate"]["700"],
    "colorProcessStepBackgroundHoverTertiary": globals["colorScales"]["slate"]["800"],
    "colorProcessStepBackgroundHoverWarning": globals["colorScales"]["orange"]["500"],
    "colorProcessStepBackgroundPrimaryDefault": globals["colorScales"]["slate"]["900"],
    "colorProcessStepBackgroundPrimarySelected": globals["colorScales"]["slate"]["600"],
    "colorProcessStepBackgroundSecondaryDefault": globals["colorScales"]["slate"]["800"],
    "colorProcessStepBackgroundWarningDefault": globals["colorScales"]["orange"]["600"],
    "colorProcessStepBackgroundWarningSecondary": globals["colorScales"]["orange"]["400"],
    "colorProcessStepBackgroundWarningSelected": globals["colorScales"]["orange"]["500"],
    "colorProcessStepBorderDefault": globals["colorScales"]["slate"]["700"],
    "colorProcessStepBorderDisabled": globals["colorScales"]["slate"]["700"],
    "colorProcessStepBorderErrorDefault": globals["colorScales"]["red"]["700"],
    "colorProcessStepBorderErrorHover": globals["colorScales"]["red"]["600"],
    "colorProcessStepBorderErrorSelected": globals["colorScales"]["red"]["500"],
    "colorProcessStepBorderHover": globals["colorScales"]["slate"]["600"],
    "colorProcessStepBorderSelected": globals["colorScales"]["slate"]["500"],
    "colorProcessStepBorderWarningDefault": globals["colorScales"]["orange"]["500"],
    "colorProcessStepBorderWarningHover": globals["colorScales"]["orange"]["400"],
    "colorProcessStepBorderWarningSelected": globals["colorScales"]["orange"]["300"],
    "colorProcessStepIconDefault": globals["colorScales"]["slate"]["200"],
    "colorProcessStepIconErrorPrimary": globals["colorScales"]["red"]["400"],
    "colorProcessStepIconErrorSecondary": globals["colorScales"]["red"]["300"],
    "colorProcessStepIconWarningPrimary": globals["colorScales"]["orange"]["300"],
    "colorProcessStepIconWarningSecondary": globals["colorScales"]["orange"]["200"],
    "colorProcessStepTextDisabled": globals["colorScales"]["slate"]["400"],
    "colorProcessWrapperBackgroundPrimary": globals["colorScales"]["slate"]["900"],
    "colorProcessWrapperBackgroundSecondary": globals["colorScales"]["slate"]["800"],
    "colorProgressBackgroundLinear": globals["colorScales"]["slate"]["300"],
    "colorProgressBackgroundPrimary": globals["colorScales"]["slate"]["300"],
    "colorProgressBackgroundSecondary": globals["colorScales"]["slate"]["600"],
    "colorProgressForegroundCircular": globals["colorScales"]["slate"]["500"],
    "colorProgressForegroundLinear": globals["colorScales"]["slate"]["600"],
    "colorProgressTextInfo": globals["colorScales"]["slate"]["400"],
    "colorScrollbarBackground": "rgb(from #111A23 r g b / 0)",
    "colorScrollbarHandle": globals["colorScales"]["slate"]["500"],
    "colorSearchBackgroundNotice": globals["colorScales"]["slate"]["700"],
    "colorSearchBackgroundResultHover": globals["colorScales"]["slate"]["700"],
    "colorSearchBackgroundResultPressed": globals["colorScales"]["slate"]["600"],
    "colorSpaceSwitcherBackgroundDefault": "rgb(from #3D4653 r g b / 0.64)",
    "colorSpaceSwitcherBackgroundHover": globals["colorScales"]["slate"]["500"],
    "colorSpaceSwitcherBackgroundPressed": globals["colorScales"]["slate"]["500"],
    "colorSpaceSwitcherBorderPrimary": "rgb(from #16191F r g b / 0.16)",
    "colorSpaceSwitcherIconDefault": globals["colorScales"]["slate"]["300"],
    "colorSpaceSwitcherTextDefault": globals["colorScales"]["slate"]["300"],
    "colorSpaceSwitcherTextHover": globals["colorScales"]["white"],
    "colorSpaceSwitcherTextPressed": globals["colorScales"]["white"],
    "colorStatusBadgeBackgroundHealthy": globals["colorScales"]["green"]["600"],
    "colorStatusBadgeBackgroundNeutral": globals["colorScales"]["slate"]["600"],
    "colorStatusBadgeBackgroundUnhealthy": globals["colorScales"]["red"]["600"],
    "colorStatusBadgeBackgroundWarning": globals["colorScales"]["yellow"]["600"],
    "colorStatusBadgeIconDefault": globals["colorScales"]["white"],
    "colorStatusBadgeIconInverse": globals["colorScales"]["slate"]["100"],
    "colorStatusBadgeTextInverse": globals["colorScales"]["slate"]["100"],
    "colorStatusBadgeTextPrimary": globals["colorScales"]["slate"]["100"],
    "colorSwitchBackgroundOffDefault": globals["colorScales"]["slate"]["500"],
    "colorSwitchBackgroundOffDisabled": globals["colorScales"]["slate"]["700"],
    "colorSwitchBackgroundOnDefault": globals["colorScales"]["blue"]["200"],
    "colorSwitchBackgroundOnDisabled": globals["colorScales"]["blue"]["600"],
    "colorSwitchForegroundOffDefault": globals["colorScales"]["slate"]["300"],
    "colorSwitchForegroundOffDisabled": globals["colorScales"]["slate"]["600"],
    "colorSwitchForegroundOnDefault": globals["colorScales"]["blue"]["400"],
    "colorSwitchForegroundOnDisabled": globals["colorScales"]["blue"]["700"],
    "colorSwitchIconActive": globals["colorScales"]["slate"]["100"],
    "colorSwitchOverlayOff": "rgb(from #68778D r g b / 0.16)",
    "colorSwitchOverlayOn": "rgb(from #F5F6F8 r g b / 0.16)",
    "colorTableBackgroundDangerDefault": globals["colorScales"]["red"]["700"],
    "colorTableBackgroundDangerHover": "rgb(from #802424 r g b / 0.75)",
    "colorTableBackgroundSuccessDefault": globals["colorScales"]["green"]["700"],
    "colorTableBackgroundSuccessHover": "rgb(from #00502E r g b / 0.75)",
    "colorTableHeaderBackground": "rgb(from #282F38 r g b / 0.3)",
    "colorTableTextDanger": globals["colorScales"]["red"]["200"],
    "colorTagBackground": globals["colorScales"]["slate"]["800"],
    "colorTagText": globals["colorScales"]["slate"]["200"],
    "colorTextDanger": globals["colorScales"]["red"]["300"],
    "colorTextDisabled": globals["colorScales"]["slate"]["600"],
    "colorTextFeature": globals["colorScales"]["purple"]["300"],
    "colorTextFieldBorderActive": globals["colorScales"]["slate"]["100"],
    "colorTextFieldBorderDanger": globals["colorScales"]["red"]["400"],
    "colorTextFieldBorderDefault": globals["colorScales"]["slate"]["700"],
    "colorTextFieldBorderDisabled": globals["colorScales"]["slate"]["700"],
    "colorTextFieldBorderHover": globals["colorScales"]["slate"]["500"],
    "colorTextFieldIconDisabled": globals["colorScales"]["slate"]["600"],
    "colorTextFieldIconPrimary": globals["colorScales"]["slate"]["200"],
    "colorTextFieldTextDanger": globals["colorScales"]["red"]["400"],
    "colorTextFieldTextDisabled": globals["colorScales"]["slate"]["600"],
    "colorTextFieldTextPrimary": globals["colorScales"]["slate"]["100"],
    "colorTextFieldTextSecondary": globals["colorScales"]["slate"]["300"],
    "colorTextFieldTextSelected": globals["colorScales"]["slate"]["100"],
    "colorTextInfo": globals["colorScales"]["slate"]["200"],
    "colorTextInversePrimary": globals["colorScales"]["slate"]["900"],
    "colorTextInverseSecondary": globals["colorScales"]["slate"]["800"],
    "colorTextLinkDefault": globals["colorScales"]["slate"]["200"],
    "colorTextLinkHover": globals["colorScales"]["slate"]["400"],
    "colorTextPrimary": globals["colorScales"]["slate"]["100"],
    "colorTextSecondary": globals["colorScales"]["slate"]["300"],
    "colorTextSelected": globals["colorScales"]["slate"]["400"],
    "colorTextSuccess": globals["colorScales"]["green"]["300"],
    "colorTextTertiary": globals["colorScales"]["slate"]["400"],
    "colorTextWarning": globals["colorScales"]["yellow"]["200"],
    "shadowDrawer": "-4px 0 16px 0 rgba(0,0,0,0.16), -12px 4px 24px -4px rgba(0,0,0,0.32)",
    "shadowExtraSmall": "0 1px 8px 0 rgba(0,0,0,0.12), 0 1px 2px 0 rgba(0,0,0,0.06)",
    "shadowFocused": "0 0 0 1px rgb(68,155,225), 0 0 0 5px rgba(68,155,225,0.4)",
    "shadowFocusedInset": "inset 0 0 0 4px rgba(68,155,225,0.4)",
    "shadowLarge": "0 2px 6px 0 rgba(0,0,0,0.26), 0 24px 32px -4px rgba(0,0,0,0.42)",
    "shadowLayoutPrimary": "-2px -2px 16px 0 rgba(0,0,0,0.06)",
    "shadowMedium": "0 0 4px 0 rgba(0,0,0,0.24), 0 6px 12px 0 rgba(0,0,0,0.3)",
    "shadowSmall": "0 1px 1px 0 rgba(0,0,0,0.16), 0 1px 8px 0 rgba(0,0,0,0.16)"
};